import React from 'react';
import { termsOfServiceContent } from '../data';
import { TermsOfServiceProps } from '../types';
import TermsOfServicePresentation from './TermsOfServicePresentation';

const TermsOfServiceContainer: React.FC<TermsOfServiceProps> = ({ 
  className,
  id = 'terms-of-service'
}) => {
  const { heading, lastUpdated, sections, disclaimer } = termsOfServiceContent;
  const props = {
    id,
    heading,
    lastUpdated,
    sections
  };

  // Add disclaimer only if it exists
  if (disclaimer) {
    Object.assign(props, { disclaimer });
  }

  return <TermsOfServicePresentation {...props} />;
};

export default TermsOfServiceContainer;